import React from "react";
import ReactWOW from 'react-wow';
import { $t } from '@/modules/i18n';

const Judges = ({ Message: msg}) => {
  return (
    <section id="judge">
        <div className="container">
          <div className="title-block">
            <h2>{$t(msg.judge)}</h2>
          </div>
          <div className="judge-list">
            {
              msg.judgeData.map((item, index) => {
                return (
                  <ReactWOW animation="fadeInUp" delay="0.1s" key={index}>
                    <div className="judge-data">
                      <img className="icon" src={require("@uh/assets/images/bullet.svg")} alt="bullet point"/>
                      <div className="text-section">
                        <h4>{$t(item.title)}</h4>
                        <ul>
                          {item.li.map(listItem =>
                            <li key={listItem}>{$t(listItem)}</li>
                          )}
                        </ul>
                      </div>
                    </div>
                  </ReactWOW>
                )
              })
            }
          </div>
        </div>
      </section>
  )
}


export default Judges;